import { ComponentType, PageType } from '../enums';
import { sortSelect } from 'store/search/searchActions';
import { createSortSelectEvent } from '../eventCreators';
import { createSortSelectEventPayload } from '../dataHelpers/createSortSelectEventPayload';

const emitSortSelectEvent = ({ payload }) => {
  return createSortSelectEvent(
    createSortSelectEventPayload({
      sortField: payload.sortField,
      sortOrder: payload.sortOrder,
      componentVariant: 'search results sort',
      componentType: ComponentType.SORT,
      pageType: PageType.SEARCH,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [sortSelect]: emitSortSelectEvent };
